import {ReportLanguage, ScanTypes} from "../model/weak-entities";
import {ScanViewType} from "../model/scan";
import * as loadImage from "blueimp-load-image";
import Decimal from "decimal.js";
import {TranslateService} from "@ngx-translate/core";

class DictValues<V> {
  [key: string]: V;
  [key: number]: V;
}

interface ToStringer {
  toString(): string;
}

export function setReportLanguage(language: string, translate: TranslateService) {
  console.log(language)
  switch (ReportLanguage[language]) {
    case ReportLanguage.French:
      translate.use('fr');
      console.log('setting language to FR');
      break;
    case ReportLanguage.German:
      translate.use('de');
      console.log('seeting language to DE');
      break;
    case ReportLanguage.English:
      translate.use('en');
      console.log('setting language to EN');
      break;
    case ReportLanguage.Spanish:
      translate.use('sp');
      console.log('setting language to SP');
      break;
    case ReportLanguage.Dutch:
      translate.use('nl');
      console.log('setting language to NL');
      break;
    case ReportLanguage.Italian:
      translate.use('it');
      console.log('setting language to IT');
      break;
    case ReportLanguage.Norwegian:
      translate.use('no');
      console.log('setting language to NO');
      break;
    case ReportLanguage.Portuguese:
      translate.use('pt');
      console.log('setting language to PT');
      break;
    default:
      break;
  }
}
export class Dict<K extends ToStringer, V> {
  private _values: DictValues<V> = Object.create(null);

  get(key: K): V {
    return this._values[key.toString()];
  }

  set(key: K, value: V): void {
    this._values[key.toString()] = value;
  }

  has(key: K): boolean {
    return this._values.hasOwnProperty(key.toString());
  }

  values(): DictValues<V> {
    return this._values;
  }
}

export function getImageWithOrientation(image: any): Promise<string> {
  return new Promise<string>(resolve => {
    loadImage.parseMetaData(image, (data) => {
      //default image orientation
      let orientation = 0;
      //if exif data available, update orientation
      if (data.exif) {
        orientation = data.exif.get('Orientation');
      }

      let loadingImage = loadImage(
        image,
        (canvas) => {
          //here's the base64 data result
          let base64data = canvas.toDataURL('image/jpeg');
          //here's example to show it as on imae preview
          //var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, '');
          resolve(base64data);

        }, {
          //should be set to canvas : true to activate auto fix orientation
          canvas: true,
          orientation: orientation
        }
      );
    });
  });
}

export function ScanTypeDecoder(value) {
  let valueString = value.toString();
  let typedValueString = valueString as keyof ScanTypes;
  return ScanTypes[typedValueString];
}

export function ScanTypeDisplayName(scanType) {
  switch (scanType) {
    case ScanTypes.EMG:
      return "neuroCORE";
    case ScanTypes.HRV:
      return "neuroPULSE";
    case ScanTypes.RollingThermal:
    case ScanTypes.Thermal:
      return "neuroTHERMAL";
    case ScanTypes.ROM:
      return "spineROM";
    case ScanTypes.Algo:
      return "spineSENSE";
  }
  return "";
}

export function ScanTypeImageName(scanType) {
  switch (scanType) {
    case ScanTypes.EMG:
      return "cla-neuroCore";
    case ScanTypes.HRV:
      return "cla-neuroPulse";
    case ScanTypes.RollingThermal:
    case ScanTypes.Thermal:
      return "cla-neuroThermal";
    case ScanTypes.ROM:
      return "cla-spineRom";
    case ScanTypes.Algo:
      return "cla-spineSense";
  }
  return "";
}

export function GetDateString(created: Date) {
  let scanDate = new Date(created.toString());
  return scanDate.toLocaleString();
}

export function GetScanViewName(view: string):string {
  switch (ScanViewType[view]) {
    case ScanViewType.ALGO:
      return 'spineSENSE Bars';
    case ScanViewType.ALGO_TABLE:
      return 'spineSENSE Table';
    case ScanViewType.EMG_AMPLITUDE:
      return 'neuroCORE Amplitude';
    case ScanViewType.EMG_ASYMMETRY:
      return 'neuroCORE Asymmetry';
    case ScanViewType.EMG_ENHANCED:
      return 'neuroCORE Enhanced';
    case ScanViewType.EMG_LIVE:
      return 'neuroCORE Live';
    case ScanViewType.EMG_PATTERN:
      return 'neuroCORE Pattern';
    case ScanViewType.EMG_TABLE:
      return 'neuroCORE Table';
    case ScanViewType.HRV_HEART_RATE:
      return 'neuroPULSE Heart Rate';
    case ScanViewType.HRV_PULSE:
      return 'neuroPULSE Pulse';
    case ScanViewType.HRV_RAINBOW:
      return 'neuroPULSE Rainbow Graph';
    case ScanViewType.HRV_TABLE:
      return 'neuroPULSE Table';
    case ScanViewType.ROM_GRAPH:
      return 'spineROM Bar Graph';
    case ScanViewType.ROM_TABLE:
      return 'spineROM Table';
    case ScanViewType.THERMAL_LINE:
      return 'neuroTHERMAL Line Graph';
    case ScanViewType.THERMAL_NCM:
      return 'neuroTHERMAL Bar Graph';
    case ScanViewType.THERMAL_SUMMARY:
      return 'neuroTHERMAL Summary';
    case ScanViewType.THERMAL_TABLE:
      return 'neuroTHERMAL Table';
    case ScanViewType.THERMAL_DTG:
      return 'neuroTHERMAL DTG';
    case ScanViewType.COMPARATIVE:
      return 'Comparative Scan';
    case ScanViewType.THERMAL_NORMATIVE:
      return 'Thermal Normative';
    case ScanViewType.HRV_NORMATIVE:
      return 'HRV Normative';
    case ScanViewType.EMG_NORMATIVE:
      return 'EMG Normative';
    default:
      return 'Choose Scan View';
  }

}

export async function delay(ms: number) {
  return new Promise( resolve => setTimeout(resolve, ms) );
}

export function FtoC(degrees: Decimal, metric: boolean): Decimal {
  if(metric) return (degrees.minus(32)).times(5/9)

  return degrees;
}

export function getWeekStart(d) {
  d = new Date(d);
  var day = d.getDay(),
    diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return new Date(d.setDate(diff));
}

export function getWeekEnd(d) {
  d = new Date(d);
  var day = getWeekStart(d);
  var diff = day.getDate() + 6; // adjust when day is sunday
  return new Date(d.setDate(diff));
}





// WEBPACK FOOTER //
// ./src/utils/utils.ts